export default "__VITE_ASSET__NvgjGC5t__"